export const GET_LIST = 'GET_LIST';
export const GET_LIST_SUCCESS = 'GET_LIST_SUCCESS';
export const GET_LIST_ERROR = 'GET_LIST_ERROR';
export const GET_TRENDING_LIST = 'GET_TRENDING_LIST';
export const GET_TRENDING_LIST_SUCCESS = 'GET_TRENDING_LIST_SUCCESS';
export const GET_TRENDING_LIST_ERROR = 'GET_TRENDING_LIST_ERROR';
export const GET_SITE_LIST_SUCCESS = 'GET_SITE_LIST_SUCCESS';
export const CREATE_LIST = 'CREATE_LIST';
export const CREATE_LIST_SUCCESS = 'CREATE_LIST_SUCCESS';
export const CREATE_LIST_ERROR = 'CREATE_LIST_ERROR';
export const DELETE_LIST = 'DELETE_LIST';
export const DELETE_LIST_SUCCESS = 'DELETE_LIST_SUCCESS';
export const DELETE_LIST_SUCCESS_EVENT = 'DELETE_LIST_SUCCESS_EVENT';
export const DELETE_LIST_ERROR = 'DELETE_LIST_ERROR';
export const CLEAR_LIST_ERROR = 'CLEAR_LIST_ERROR';
export const SET_SYNC_ERRORS = 'SET_SYNC_ERRORS';
export const LOAD_TRENDING_ITEMS = 'LOAD_TRENDING_ITEMS';
export const LOAD_TRENDING_ITEMS_SUCCESS = 'LOAD_TRENDING_ITEMS_SUCCESS';
export const LOAD_TRENDING_ITEMS_ERROR = 'LOAD_TRENDING_ITEMS_ERROR';
export const SAVE_TO_LIST = 'SAVE_TO_LIST';
export const SAVE_TO_LIST_SUCCESS = 'SAVE_TO_LIST_SUCCESS';
export const RESET_LIST = 'RESET_LIST';
export const SAVE_TO_LIST_ERROR = 'SAVE_TO_LIST_ERROR';
export const GET_SAVED_LIST = 'GET_SAVED_LIST';
export const GETSAVED_LIST_SUCCESS = 'GETSAVED_LIST_SUCCESS';
export const GETSAVED_LIST_ERROR = 'GETSAVED_LIST_ERROR';
export const CREATE_LIST_SUCCESS_EVENT = 'CREATE_LIST_SUCCESS_EVENT';
export const CREATE_LIST_ERROR_EVENT = 'CREATE_LIST_ERROR_EVENT';
export const PAGE_LOAD_ANALYTICS_ACTION = 'PAGE_LOAD_ANALYTICS_ACTION';
export const COPY_LIST_SUCCESS_MSG = 'COPY_LIST_SUCCESS_MSG';
export const ADD_TO_CART_LIST_ITEM_ID = 'ADD_TO_CART_LIST_ITEM_ID';
// Gift registry action types
export const GIFT_REGISTRY_PAGE_LOAD_ACTION = 'GIFT_REGISTRY_PAGE_LOAD_ACTION';
